import { isLystUrl } from "web/script/utils/url";

export function setPaidSessionIdOnUrl(pathOrUrl: string, paidSessionId: string | null): string {
    if (!paidSessionId || !isLystUrl(pathOrUrl)) {
        return pathOrUrl;
    }

    const [url, queryString] = pathOrUrl.split("?");
    const searchParams = new URLSearchParams(queryString);
    searchParams.set("paid_session_id", paidSessionId);
    return `${url}?${searchParams.toString()}`;
}
